<template>
<div>
  <!--prmanent-emp ref="prementEmp" refId="prementEmp" title="상주직원 정보 입력" :items="modalItems"/>
  <out-info ref="outInfo" refId="outInfo" title="퇴실정보입력" :items="modalItems"/>
  <enter-info ref="enterInfo" title="입실정보입력" :items="modalItems" :key="uniqueKey"/-->

  <!--Header Start-->
  <page-header title="입퇴실 관리" description="입퇴실 관리 목록입니다.">
    <div class="btn-wrap">
      <button class="btn btn-lg light-blue" @click="emp()">
        <i class="icon-plus mr-5"></i> 상주직원
      </button>
      <button class="btn btn-lg" @click="findAll()">
        <i class="icon-refresh mr-5"></i> 새로고침
      </button>
    </div>
  </page-header>



  <!--Function Btn, Filter Start-->
  <div class="page-body ph-30">
    <div class="sticky-holder">
      <div class="control-group space-between sticky">
        <div class="inner-wrap">
          <div class="btn-group m-r-xs">
            <button type="button" class="btn btn-md line-1"  @click="enter()" :disabled="enabledCheckIn()"> 입실</button>
            <button type="button" class="btn btn-md line-1" @click="out()" :disabled="enabledCheckOut()"> 퇴실</button>
          <button type="button" class="btn btn-md line-1" @click="cancelEnter()" :disabled="enabledEnterCancel()"> 요청 취소</button>
          </div>
            <button type="button" class="btn btn-md line-1" @click="returnCard()" :disabled="enabledReturnCard()"> 카드 반납</button>
        </div>

        <div class="inner-wrap">
          <div class="input-group align-top mr-10">
            <dropdown v-model="searchTypeItem" :datasource="searchTypeList" title="" :isSelectionFirstData="false" inline="inline"/>
            <input type="text" class="form-control" v-model="term">
            <button type="button" class="btn btn-m search" @click="searchClick()">
              <i class="icon-search"></i>
            </button>
          </div>



          <div class="input-group">
            <span class="input-group-addon title">필터</span>
            <div class="dropdown inline filtering">
              <button type="button" class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" style="width:300px" >
                <div style="text-align:left;display:inline-block;width:calc(100% - 20px)">
                <span class="item">
                  <span class="text-999">출입 상태:</span>
                  <i class="icon-check"></i>{{getCheckedItem(statusDropList)}}</span>
                <span class="item">
                  <span class="text-999">출입 타입:</span>
                  <i class="icon-check"></i>{{getCheckedItem(typeDropList)}}</span>
                <!--<span class="item">-->
                  <!--<span class="text-999">IDC:</span>-->
                  <!--<i class="icon-check"></i>{{getCheckedItem(getIdc)}}</span>-->
                </div>
              </button>
              <div class="dropdown-menu dropdown-menu-scale pull-right" style="visibility: visible;">
                <div class="form-group">
                  <label class="form-control-label">출입 상태</label>
                  <div>
                    <label class="md-check" v-for="(item, index) in statusDropList" :key="index">
                      <input type="radio" class="has-value" name="status" v-model="selectedStatsItem" :value="item.value" @click="selectedFilter(item, 'statusDropList', 'selectedStatsItem')">
                      <i class="blue"></i>{{item.name}}
                    </label>
                  </div>
                </div>
                <div class="dropdown-divider"></div>
                <div class="form-group">
                  <label class="form-control-label">출입 타입</label>
                  <div>
                    <label class="md-check" v-for="(item, index) in typeDropList" :key="index">
                      <input type="radio" class="has-value" name="type" v-model="selectedTypeItem" :value="item.value"  @change="selectedFilter(item, 'typeDropList', 'selectedTypeItem')">
                      <i class="blue"></i>{{item.name}}</label>
                  </div>
                </div>
                <!--<div class="dropdown-divider"></div>-->
                <!--<div class="form-group">-->
                  <!--<label class="form-control-label">IDC</label>-->
                  <!--<div>-->
                    <!--<label class="md-check" v-for="(item, index) in getIdc" :key="index">-->
                      <!--<input type="radio" class="has-value" name="idc" v-model="idcSelctedItem" :value="item.value" @change="selectedFilter(item, 'getIdc', 'idcSelctedItem')">-->
                      <!--<i class="blue"></i>{{item.name}}</label>-->
                  <!--</div>-->
                <!--</div>-->
                <!--<div class="dropdown-divider"></div>-->
                <!--<div class="btn-groups">-->
                  <!--<button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close">-->
                    <!--<i class="icon-close mr-5"></i>취소</button>-->
                  <!--<button class="btn btn-lg light-blue" @click="searchClick()">-->
                    <!--<i class="icon-check mr-5"></i>적용</button>-->
                <!--</div>-->
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <!--Table Start-->
    <data-table :datasource="items" :noDataSpan="currentIdc.locationCode == 'N2CDT014070' ? 12 : 11">
      <template v-slot:header>
        <data-table-header-column name="checked" displayName="" width="50px">
          <label class="md-check">
            <input type="checkbox" @change="check" v-model="checkedAll">
            <i class="blue"></i>
          </label>
        </data-table-header-column>
        <data-table-header-column name="ntreeTicket" displayName="티켓번호" width="15%"/>
        <data-table-header-column name="visitorName" displayName="이름" width="10%"/>
        <data-table-header-column name="visitorCompany" displayName="회사명" width="15%"/>
        <data-table-header-column name="statusCode" displayName="상태" width="10%"/>
        <data-table-header-column name="fromDate" displayName="입실시간" width="10%"/>
        <data-table-header-column name="toDate" displayName="퇴실시간" width="10%"/>
        <data-table-header-column name="empName" displayName="카드번호" width="10%"/>
        <data-table-header-column name="assetList" displayName="반입요청자산" width="150px" />
        <data-table-header-column v-if="currentIdc.locationCode == 'N2CDT014070'" displayName="숙소정보" width="100px"/>
        <data-table-header-column name="elev" displayName="화물E/V" width="100px"/>
        <data-table-header-column name="more" displayName="" width="50px"/>
      </template>
      <!--<template v-if="total != 0 && item.checkOutTimestamp == null" v-for="(item, $index) in items">-->
      <template v-if="total != 0" v-for="(item, $index) in items">
        <tr v-bind:key="$index" :class="[selectedIndex == item.checkInIndex ? 'expanded' : null]">
          <data-table-column name="checked" displayName="" width="50px">
            <label class="md-check">
              <input type="checkbox" v-model="item.checked" @change="checkboxChange">
              <i class="blue"></i>
            </label>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="티켓번호" :style="item.visitor.ntreeTicket ? 'cursor:pointer;color:#187ed6;' : ''" @click="goNtreeTicket(item.visitor.ntreeTicket)">
              {{item.visitor.ntreeTicket == null ? item.visitor.reservationType : item.visitor.ntreeTicket}}
              <i v-if="item.visitor.ntreeTicket" class="icon-move-link"></i>
            </span>
          </data-table-column>
          <data-table-column name="checked" displayName="" >
            <span class="td-text ellipsis" data-original-title="이름">{{item.visitor.visitorName}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="회사명">{{item.visitor.visitorCompany}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="상태"><i :class="['dot', getStatus(item)]"></i> {{getCodeByKey('visitStatus', 'statusCode', item.visitor.statusCode).statusStr}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="입실시간">{{item.checkInTimestamp ? getDate(item.checkInTimestamp).slice(0,-3) : '-'}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="퇴실시간">{{item.checkOutTimestamp ? getDate(item.checkOutTimestamp).slice(0,-3) : '-'}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="카드번호">{{item.cardNumber}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="반입자산">{{getAssetNames(item.visitor.assetList)}}</span>
          </data-table-column>
          <data-table-column v-if="currentIdc.locationCode == 'N2CDT014070'" name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="숙소정보" :style="item.roomNumber && isTodayBook(item) ? 'cursor:pointer;color:#187ed6;' : ''" @click="goBookingManager()">
              {{item.roomNumber != null && isTodayBook(item)  ? item.roomNumber : ''}}
              <i v-if="item.roomNumber && isTodayBook(item)" class="icon-move-link"></i>
            </span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="elev">{{item.visitor.isElev == 1 ? '사용' : ''}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <a @click="itemClick(item)">
              <i :class="['icon', selectedIndex == item.checkInIndex ? 'icon-arrow-line-up' : 'icon-arrow-line-down']"></i>
            </a>
          </data-table-column>
        </tr>
        <ManagerForm :item="item" v-bind:key="'detail-'+$index" v-if="selectedIndex == item.checkInIndex"/>
      </template>
    </data-table>
    <Pagenation ref="paging" :datasource="resultData" @pageChange="pageChange"/>
  </div>

</div>
</template>

<script>
import PageHeader from '@/layout/PageHeader.vue';
import DataTableBase from '@/components/common/dataTableBase';
import DataTable from '@/components/common/DataTable.vue';
import DataTableHeaderColumn from '@/components/common/DataTableHeaderColumn.vue';
import DataTableColumn from '@/components/common/DataTableColumn.vue';
import Pagenation from '@/components/common/Pagenation';
import Dropdown from '@/components/Dropdown.vue';
import ManagerForm from './ManagerForm.vue';

import EnterInfo from './EnterInfo.vue';
import OutInfo from './OutInfo.vue';
import PrmanentEmp from './PrmanentEmp.vue';

export default {
  mixins: [DataTableBase],
  components:{
    Pagenation,
    PageHeader,
    DataTable,
    DataTableHeaderColumn,
    DataTableColumn,
    Dropdown,
    ManagerForm,
    EnterInfo, OutInfo, PrmanentEmp
  },
  data(){

    return {
      EnterInfo:EnterInfo,
      uniqueKey: null,
      modalItems: [],
      selectedItems: null,
      isCheckedAll: false,
      selectedStatsItem: null,
      selectedTypeItem: null,
      idcSelctedItem: null,
      statusDropList: [{name: '전체', value: null, isChecked: true}, {name: '입실대기', value: 5}, {name: '입실', value: 6}, {name: '카드 미반납', value: 7}, {name: '퇴실', value: 8}],
      typeDropList: [{name: '전체', value: null, isChecked: true}, {name: 'VMS', value: 'VMS'}, {name: 'NTREE', value: 'NTREE'}, {name: 'AB등급', value: 'AB등급'}, {name: '상주직원', value: '상주직원'}],
      searchTypeItem: 'visitorName',
      searchTypeList: [{name: '이름', value: 'visitorName'}, {name: '회사명', value: 'company'}, {name: '티켓번호', value: 'ntreeTicket'}],
      userTypeItem: {},
      userTypeList: [{name:'일반사용자', value: 1}, {name: 'IDC 사용자', value: 2}, {name: 'IDC 운영자', value: 3}, {name: '보안담당자 및 시스템 관리자', value: 4}],
      idcList: [{name: '판교', value: 0}, {name: '데이터센터 각', value: 1},],
      term: '',
      searchType: 'title',
      getApi:'visitor/inOutSearch',
      paging: this.$dataProvider.paging,
      boardSearchDataSource: this.$dataProvider.boardSearchDataSource,
      total: 0,
      resultData : null,
      //rowItem : {title: '공지사항', user: '강선호', createDate: '2021-07-07', modifiedDate: '2021-07-07'},
      //items: []
    }
  },
  computed: {
    getStatus(){
      /*
      1.2 승인대기 - 노랑
      3, 5~8 승인완료 - 녹색
      4 승인 거절 - 회색
      */
      return (item) => {
        var color = 'grey'
        if(item.visitor.statusCode == 5)
          color = 'yellow';
        if(item.visitor.statusCode == 6)
          color = 'green';
        if(item.visitor.statusCode == 7)
          color = 'red';
        return color;
      }
    },
    getAssetNames() {
      return (assets) => {
        return _.map(assets, x => x.visitorAssetCode.assetStr).join(', ')
        //return assets
      }
    },
    getCheckedItem() {
      return (items) => {
        var result = '전체';
        var o = _.find(items, {isChecked:true})
        if(o && o.name){
          result = o.name;
        }
        return result;
      }
    },


    currentIdc(){
      return this.$store.state.location.currentIdc;
    }
  },
  watch: {
    currentIdc(nVal, oVal){
      this.load();
    },
    items(nVal, oVal){
      let yesterdayVisitors = nVal.filter(visitor => {
        let checkinDate = moment(visitor.checkInTimestamp).format('YYYY-MM-DD');
        let todayDate = moment(new Date()).format('YYYY-MM-DD');
        return visitor.checkInTimestamp != null && visitor.checkOutTimestamp == null && (checkinDate != todayDate);
      });

      if(yesterdayVisitors.length > 0) this.noti('퇴실 확인 요망', '금일 이전 출입자가 존재합니다.', 'warning');
    }
  },
  mounted(){
    //검색어 세팅
    let query = Object.assign({},this.$route.query);
    let matched = this.searchTypeList.filter((x) => {
      return query[x.value];
    });
    if(matched.length > 0) {
      this.searchTypeItem = matched[0].value;
      this.term = query[matched[0].value];
    }

    this.querySetting(this.statusDropList, query.statusCode, 'selectedStatsItem');
    this.querySetting(this.typeDropList, query.reservationType, 'selectedTypeItem');
    this.searchClick();
  },
  methods: {
    enabledCheckIn(){
      console.log('asdf')
      if(this.items.filter(x=>x.visitor.statusCode != 5 && x.checked).length > 0 || this.items.filter(x=>x.checked).length <= 0){
        return true;
      }
      //서로 다른 티켓일 경우 동시 입실 처리 금지
      let ticketSet = new Set(this.items.filter(x=>x.checked).map(x => x.visitor.ntreeTicket));
      if(ticketSet.size > 1) return true;

      return false;
    },
    enabledCheckOut(){
      if(this.items.filter(x=>x.visitor.statusCode != 6 && x.checked).length > 0 || this.items.filter(x=>x.checked).length <= 0)
        return true;
      return false;
    },
    enabledEnterCancel(){
      if(this.items.filter(x=>x.visitor.statusCode != 5 && x.checked).length > 0 || this.items.filter(x=>x.checked).length <= 0)
        return true;
      return false;
    },
    enabledReturnCard(){
      if(this.items.filter(x=>x.visitor.statusCode != 7 && x.checked).length > 0 || this.items.filter(x=>x.checked).length <= 0)
        return true;
      return false;
    },
    querySetting(list, value, target){



      //param 미입력 시 undefined 로 오므로 null 로 바꾸어줌
      if(!value) value = null;

      let matched = list.filter(x => x.value == value);
      if(matched.length == 0) value = null;

      this[target] = value;
      list.forEach((x)=>{
        x.isChecked = false;
        if(x.value == value) {
          x.isChecked = true;
          // target = x.value;
        }
      });
    },
    load(){
      let query = Object.assign({},this.$route.query);

      if(!query.limit || !query.offset){
        Object.entries(this.paging).forEach((data) => {
          query[data[0]] = data[1];
        });
      }

      query.visitIdcCode = this.currentIdc.locationCode;
      this.$router.push({query: query}).then(() => {
        this.findAll();
      }).catch(() => {
        this.findAll();
      });

    },

    searchClick(){


      //URL PARAM 초기화
      var query = Object.assign({},this.$route.query);
      // console.log(query);
      this.searchTypeList.forEach((x) => {delete query[x.value]})
      delete query.statusCode;
      delete query.reservationType;



      if(this.term) {
        query[this.searchTypeItem] = this.term.trim();
      }

      if(this.selectedStatsItem){
        query.statusCode = this.selectedStatsItem;
      }

      if(this.selectedTypeItem) {
        query.reservationType = this.selectedTypeItem
      }

      //첫번째 페이지로 조회
      query.offset = 1;

      this.$router.push({query: query}).then(() => {
        this.load();
      }).catch(() => {
        this.load();
      });
    },

    selectedFilter(item, list, target){

      //@change="selectedFilter(item, 'typeDropList', 'selectedTypeItem')"

      //선택되어있는거 false 로 만들고
      this[list].forEach((x)=>{
        x.isChecked = false;
      })
      //선택한 아이템을 true
      item.isChecked = true;

      this[target] = item.value;
      this.searchClick();
    },

    pageChange(event){
      if(event) this.paging = event.data;

      var query = Object.assign({},this.$route.query);
      this.searchTypeList.forEach((x) => {delete query[x.value]})
      query.limit = this.paging.limit;
      query.offset = this.paging.offset;
      this.$router.push({ path: this.$route.path, query: query});

      this.findAll();
    },
    itemClick(item){
      if(this.selectedIndex != item.checkInIndex){
        this.selectedIndex = item.checkInIndex;
      } else{
        this.selectedIndex = null;
      }

    },



    // view(){
    //   var query = Object.assign({},this.$route.query);
    //   query.mode = 'view';
    //   this.$router.push({ path: '/app/notice', query: query})
    //   this.findAll();
    // },



    enter(){
      this.modalItems = this.copyNew(this.items.filter((x) => {return x.checked}))
      this.openModal({view: 'app/inOut/EnterInfo', side: false, mode: 'new' , title: '출입자 별 입실 정보 입력', data: this.modalItems, showBottom: false})
    },
    out(){
      this.modalItems = this.copyNew(this.items.filter((x) => {return x.checked}))
      console.log(this.modalItems);
      this.openModal({view: 'app/inOut/OutInfo', side: false, mode: 'new' , title: '출입자 별 입실 정보 입력', data: this.modalItems, showBottom: false})
    },
    emp(){
      this.modalItems = this.copyNew(this.items.filter((x) => {return x.checked}))
      this.openModal({view: 'app/inOut/PrmanentEmp', side: false, mode: 'new' , title: '출입자 별 입실 정보 입력', data: this.modalItems, showBottom: false})
    },
    cancelEnter(){
      var arr = _.map(this.items.filter(x=>x.checked),'checkInIndex');
      this.$http.post('/api/private/visitor/enterCancel', arr)
        .then((result) => {
          // this.$toast.success('입실 요청이 취소되었습니다.');
          this.noti('완료', '입실 요청이 취소되었습니다.', 'success');
          this.findAll();
        }).catch((e) =>{
          console.log(e);
      })
    },
    returnCard(){
      var arr = _.map(this.items.filter(x=>x.checked),'checkInIndex');
      this.$http.put('/api/private/visitor/returnCard', arr)
        .then((result) => {
          // this.$toast.success('카드 반납이 완료되었습니다.');
          this.noti('완료', '카드 반납이 완료되었습니다.', 'success');
          this.findAll();
        }).catch((e) =>{
          console.log(e);
      })
    },
    goNtreeTicket(ticketNumber) {
      if(ticketNumber) {
        let url = `http://ntree.navercorp.com/staff/ticket/popup/${ticketNumber}.html`;
        window.open(url);
      }
    },
    goBookingManager(){
      let url = `/app/manager/booking/calendar`;
      window.open(url);
    },
    isTodayBook(entranceinfo){

      let today = moment(new Date()).startOf('day').toDate().getTime();
      let result = entranceinfo.bookingFromDate <= today && entranceinfo.bookingToDate >= today;
      console.log(result)

      return result;
    }
  }
}
</script>
